import Reveal from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function Story() {
  const { t } = useLang();
  return (
    <section id="story" className="relative bg-paper py-24 sm:py-32" data-testid="story-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="ttwk-label" data-testid="story-eyebrow">
                {t.story.eyebrow}
              </p>
              <h2 className="mt-6 font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                {t.story.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p
                className="mt-12 max-w-xl font-serif text-2xl font-light leading-relaxed text-umber sm:text-3xl"
                data-testid="story-s1"
              >
                {t.story.s1}
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p
                className="mt-10 max-w-xl font-serif text-2xl font-light leading-relaxed text-umber sm:text-3xl"
                data-testid="story-s2"
              >
                {t.story.s2}
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.2}>
              <div className="img-frame overflow-hidden rounded-sm border border-clay/60 transition-transform duration-700 ease-out hover:scale-[1.02]">
                <img
                  src="/media/detail.jpg"
                  alt="Close-up of woven cord, shells and feathers from a studio piece"
                  className="aspect-[3/4] w-full object-cover"
                  loading="lazy"
                />
              </div>
              <p className="mt-4 font-serif text-sm italic text-umber/60" data-testid="story-image-caption">
                {t.story.imageCaption}
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal>
          <div className="mt-24 border-y border-clay/70 py-16 text-center sm:py-24" data-testid="story-pull">
            <p className="mx-auto max-w-4xl font-serif text-3xl font-light italic leading-snug text-terracotta sm:text-5xl lg:text-6xl">
              {t.story.pull}
            </p>
            <p className="ttwk-label mt-8">{t.story.pullSub}</p>
          </div>
        </Reveal>

        <Reveal>
          <p
            className="mx-auto mt-16 max-w-2xl font-serif text-2xl font-light leading-relaxed text-umber sm:text-3xl"
            data-testid="story-s3"
          >
            {t.story.s3}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
